import React, {Component, ReactNode} from 'react'
import EventEmitterExResident from '../../shared/pageBaseComponents/EventEmitterExResident'
import ReservationCardInformation from '../ReservationCardInformation'
import ReservationsRepository from '../ReservationsRepository'
import {NatAsyncCallFunction} from '../../../__NoAutomatedTests/common/util/Natutil'
import ReservationCard from '../components/ReservationCard'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {LeftColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import {CardList} from '../components/CommonStyle'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../styledComponents/DisplayItem'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    reservationsRepo: ReservationsRepository
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
}

interface State {
    facilityReserveConfirmLimit: string,
    reservationCardInformations: ReservationCardInformation[]
}

class RMRWaitingConfirmationComponent extends Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            facilityReserveConfirmLimit: '',
            reservationCardInformations: [],
        }
    }

    async componentDidMount(): Promise<void> {
        const {reservationsRepo, condominiumCd, eventEmitter, navigate} = this.props

        await eventEmitter.showLoading()
        try {
            const reservationsOfWaitingConfirmation = await NatAsyncCallFunction(
                reservationsRepo.getReservationsOfWaitingConfirmation.bind(
                    reservationsRepo,
                    condominiumCd,
                ),
                navigate,
            )
            if (reservationsOfWaitingConfirmation === null) {
                return
            }

            const {facilityReserveConfirmLimit, reservationCardInformations} = reservationsOfWaitingConfirmation
            if (facilityReserveConfirmLimit !== null) {
                this.setState({
                    facilityReserveConfirmLimit: facilityReserveConfirmLimit.label,
                    reservationCardInformations: reservationCardInformations,
                })
            }
        } finally {
            eventEmitter.closeLoading()
        }
    }

    handleClickReservationCard(facilityId: number, facilityReserveId: number): void {
        const {condominiumCd, navigate} = this.props

        navigate(
            `/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reservations/${facilityReserveId}/detail`,
            {state: {previousPageUrl: `/resident/condominiums/${condominiumCd}/my-reservations`}},
        )
    }

    render(): ReactNode {
        const {facilityReserveConfirmLimit, reservationCardInformations} = this.state

        if (reservationCardInformations.length === 0) {
            return null
        }

        return <>
            <BlockSpacer height={'15px'}/>
            <ContentBody>
                <WaitingConfirmation>
                    <LeftColumnFlexContainer>
                        <div>確定待ちの予約があります</div>
                        <div>{facilityReserveConfirmLimit}日までに確定してください</div>
                    </LeftColumnFlexContainer>
                </WaitingConfirmation>
                <CardList>
                    {
                        reservationCardInformations.map((cardInfo, index) => (
                            <ReservationCard
                                key={index}
                                cardInformation={cardInfo}
                                onClick={this.handleClickReservationCard
                                    .bind(this, cardInfo.facilityId, cardInfo.facilityReserveId)}
                            />
                        ))
                    }
                </CardList>
            </ContentBody>
            <BlockSpacer height={'30px'}/>
            <DisplayItemDividerForPageTop/>
        </>
    }
}

export default RMRWaitingConfirmationComponent

const ContentBody = styled.div`
  max-width: 738px;
  margin: auto;
`

const WaitingConfirmation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  width: 100%;

  color: ${Colors.Body};
  background-color: ${Colors.Surface};
  font-size: ${FontSize.Middle};
  line-height: 21px;
  font-weight: ${FontWeights.Normal};

  &::before {
    content: "";
    background: linear-gradient(135deg, rgb(239, 103, 35) 50%, rgb(216, 91, 28) 50%);
    height: 30px;
    width: 30px;
    display: inline-block;
    margin: 0 10px;
  }
`
